import { SVGProps, Ref, forwardRef } from 'react';

export const DropsFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M6.333 0s.871.83 1.911 2.188C7.548 3.415 6.93 4.975 6.93 6.667a4.73 4.73 0 0 0 4.685 4.731A5.333 5.333 0 0 1 1 10.667C1 5.073 6.298.033 6.333 0"
            fill="currentColor"
        />
        <path
            d="M11.663 0s3.334 3.16 3.334 6.667a3.334 3.334 0 0 1-6.667 0C8.33 3.172 11.64.022 11.663 0"
            fill="currentColor"
        />
    </svg>
));
DropsFilledSize16Glyph.displayName = 'DropsFilledSize16Glyph';
